import React, { useMemo, useState } from "react";
import { calcLumpsum, formatINR } from "../../lib/finance";
import { Slider, InputRow, ResultRow, SplitBar, DarkCTA, Pills, RightPanel, Divider, HeroValue } from "./CalcUI";

const goals = ["Wealth Creation", "Retirement", "Child Education", "Custom"];

export const LumpsumTab = () => {
  const [amount, setAmount] = useState(100000);
  const [returnPct, setReturnPct] = useState(12);
  const [years, setYears] = useState(10);
  const [goal, setGoal] = useState("Wealth Creation");

  const result = useMemo(() => calcLumpsum(amount, returnPct, years), [amount, returnPct, years]);
  const animKey = `lump-${Math.round(result.maturity)}-${amount}-${returnPct}-${years}`;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="p-6 sm:p-10">
        <InputRow
          label="Investment Amount"
          valueText={`Rs. ${formatINR(amount)}`}
          valueTestId="lump-amount-value"
          finePrint={<><span>Rs.1,000</span><span>Rs.1 Crore</span></>}
        >
          <Slider value={amount} min={1000} max={10000000} step={1000} onChange={setAmount} ariaLabel="Lumpsum amount" />
        </InputRow>

        <InputRow
          label="Expected Annual Return"
          valueText={`${returnPct.toFixed(1)}% per annum`}
          valueTestId="lump-return-value"
          finePrint={<><span>1%</span><span>30% per annum</span></>}
        >
          <Slider value={returnPct} min={1} max={30} step={0.1} onChange={setReturnPct} ariaLabel="Lumpsum return" />
        </InputRow>

        <InputRow
          label="Investment Period"
          valueText={`${years} ${years === 1 ? "Year" : "Years"}`}
          valueTestId="lump-tenure-value"
          finePrint={<><span>1 year</span><span>40 years</span></>}
        >
          <Slider value={years} min={1} max={40} step={1} onChange={setYears} ariaLabel="Lumpsum period" />
        </InputRow>

        <div>
          <div className="mb-3" style={{ color: "#4A5568", fontSize: 13, fontWeight: 500 }}>Investment Goal</div>
          <Pills items={goals} value={goal} onChange={setGoal} prefix="lump-goal" />
          <p className="mt-3" style={{ color: "#718096", fontSize: 11 }}>
            One-time investment compounded annually. Returns are assumed, not guaranteed. Mutual fund
            investments are subject to market risks.
          </p>
        </div>
      </div>

      <RightPanel testId="lump-results">
        <HeroValue label="Maturity Value" value={`Rs. ${formatINR(result.maturity)}`} animKey={animKey} testId="lump-maturity-value" />
        <Divider />
        <div className="space-y-3">
          <ResultRow label="Invested Amount" value={`Rs. ${formatINR(result.invested)}`} testId="lump-row-invested" />
          <ResultRow label="Est. Returns" value={`Rs. ${formatINR(result.gains)}`} valueColor="#1D9E75" testId="lump-row-gains" />
          <ResultRow label="Total Value" value={`Rs. ${formatINR(result.maturity)}`} testId="lump-row-total" />
        </div>
        <Divider />
        <SplitBar
          leftPct={result.investedPct}
          rightPct={result.gainsPct}
          leftLabel="Invested"
          rightLabel="Returns"
          leftColor="#F4A700"
          rightColor="#1D9E75"
          testId="lump-split-bar"
        />
        <DarkCTA href="mailto:invest@metamonk.co" testId="lump-start-cta">
          Invest a Lumpsum with Meta Monk
        </DarkCTA>
      </RightPanel>
    </div>
  );
};
